import ChatMentionTarget from './ChatMentionTarget';

export interface ChatGroupId {__chatGroupId: number}

export default class ChatGroup extends ChatMentionTarget<ChatGroupId> {
  static withId(id: ChatGroupId): ChatGroup {
    return this.withData({ id });
  }

  static withData(data: Partial<ChatGroup>): ChatGroup {
    return Object.assign(new ChatGroup(), data);
  }

  get typeName(): string {
    return 'group';
  }
}
